<template>
  <l-container>
    <l-container-title
      slot="toolbar"
      text="Verify"
      icon="clipboard-check"
      color="bg-pastel-orange"
    />
    <div v-show="true" class="w-full flex flex-col">
      <div class="flex mt-4 w-full">
        <div class="w-full">
          <l-select
            v-model="networkSelection"
            class="text-xs"
            :data="networks"
            placeholder="Please select a network"
            :multiple="false"
          >
            <l-option
              v-for="i in networks"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="flex mt-4">
        <div class="mr-2">
          <l-select
            v-model="yearSelection"
            class="text-xs w-4"
            :data="years"
            placeholder="Please select a year"
            :multiple="false"
          >
            <l-option
              v-for="i in years"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>

        <l-button
          type="success"
          :disabled="networkSelection == null || yearSelection == null || loading"
          @click="onClick"
        >View datasets</l-button>
      </div>
    </div>
  </l-container>
</template>
<script>
import { VerifyService } from "@/helpers/services/qualitycontrol/verify.service";
import { LSelect, LOption, LButton } from "@/components/forms";
export default {
  name: "LLSelection",
  components: {
    LSelect,
    LOption,
    LButton
  },
  props: ["networks", "loading"],
  data() {
    return {
      networkSelection: null,
      yearSelection: null
    };
  },
  computed: {
    years() {
      const sel = this.networks.find(t => {
        return t.value == this.networkSelection;
      });
      this.yearSelection = null;
      if (!sel) return [];
      return sel.years.map(y => {
        return { label: y, value: y };
      });
    }
  },
  methods: {
    onClick() {
      this.$emit("click", {
        network: this.networkSelection,
        year: this.yearSelection
      });
    }
  }
};
</script>
